import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PciLayout'

const GetAll = (pciID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${pciID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Delete = (pciLayoutID, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${pciLayoutID}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)

export default {
  GetAll,
  Create,
  Delete,
  Update
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/layoutpci.js